import './launch.scss'

const Launchshow=()=>{

    return (
        <div className="launchshow">
       
            <div className="info">Social media shared today, tomorrow or by location</div>

            <div className="ellipse"></div>

        </div>
    )

}

export default Launchshow